export default "__VITE_ASSET__ClSawwHA__"